import React, { useEffect } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './Solution.module.css';

import { rfHeaderData, rfBodytData } from './SolutionData';
import { rfid1, rfid2, rfid3, rfid4, rfid5, rfid6, rfid7, rfid8, rfid9, arrow } from '../../assets/images/solution/solutionImages';
import BasicTable from '../../components/Table/BasicTable';
import { Link } from 'react-router-dom';

const RfidPage = () => {
  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="solution" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="solution" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div style={{minHeight:'650px'}}>
            <div className={isMobile() ? 'mb-50' : 'mb-80'}>
              <img src={rfid1} alt='rfid' className={`${S.solContentImg} mt-30`} />
            </div>
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                Mifare R/W Demo란
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                ACR1252 단말기를 통해 13.56Mhz Mifare Classic S50(1K) / S70(4K) 카드의<br />
                데이터를 쉽게 관리할 수 있는 Demo 프로그램 입니다.
              </div>
              <img src={rfid2} alt='rfid' className={`${S.solContentImg} mt-20`}/>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                ACR1252 NFC Reader 사양
              </div>
              <div className={S.rfImgBtnDiv}>
                <img src={rfid3} alt='rfid' id={S.rfidImg3}/> 
                <div className={S.rdImgBtnLink}>
                  <Link className='text-line-none'>
                    <div draggable className={S.downFileDiv}>
                      <div>
                        ACR1252 보러가기
                      </div>
                      <img src={arrow} alt='arrow'/>
                    </div>
                  </Link>
                </div> 
              </div>
              <div className='mt-50'>
                <BasicTable headers={rfHeaderData} items={rfBodytData} />
              </div>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                Mifare R/w Demo의 기능
              </div>
              <img src={rfid4} alt='rfid' className={`${S.solContentImg} mt-50`}/>
              <img src={rfid5} alt='rfid' className={`${S.solContentImg} mt-30`}/>
              <div className={`${S.contentText} mt-50`}>
                <span className={S.bSmallContentText}>Data Reader/Write</span>
                <div className={S.introText}>태그의 섹터 및 블록을 지정하여 데이터를 읽기/쓰기 가능</div>
              </div>
              <img src={rfid6} alt='rfid' className={`${S.solContentImg} mt-50`}/>
              <div className={`${S.contentText} mt-50`}>
                <span className={S.bSmallContentText}>인증키 설정</span>
                <div className={S.introText}>태그의 A, B키를 변경이 가능하며, 변경된 인증키로 암호화된 블록을 읽기/쓰기 가능</div>
              </div>
              <img src={rfid7} alt='rfid' className={`${S.solContentImg} mt-50`}/>
              <div className={`${S.contentText} mt-50`}>
                <span className={S.bSmallContentText}>일괄적 데이터 변경</span>
                <div className={S.introText}>태그의 섹터와 블록을 일괄적으로 읽기/쓰기 가능</div>
              </div>
              <img src={rfid8} alt='rfid' className={`${S.solContentImg} mt-50`}/>
              <div className={`${S.contentText} mt-50`}>
                <span className={S.bSmallContentText}>엑셀 발행 기능</span>
                <div className={S.introText}>대량의 태그에 원하는 데이터를 순차적으로 쓰기(인코딩) 가능</div>
              </div>
              <img src={rfid9} alt='rfid' className={`${S.solContentImg} mt-50`}/>
              <div className={`${S.contentText} mt-50`}>
                <span className={S.bSmallContentText}>요금 충전/차감 기능</span>
                <div className={S.introText}>세차장, 빨래방, 식수관리 등 쉽게 사용할 수 있는 요금 충전 메뉴<br/>태그의 섹터와 블록을 지정하여 원하는 금액을 충전/차감 가능</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RfidPage;
